import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import DynamicArticlePage from "@/pages/article/dynamic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <DynamicArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;